export function getParamsAsDict(params) {
  if (!params) return {}
  params = decodeURIComponent(params)
  const paramArray = params.split(':')
  const paramsDict = {}
  for (const param of paramArray) {
    const [key, value] = param.split('=')
    paramsDict[key] = value
  }
  return paramsDict
}

export function generateFilterUrl(params, rootUrl) {
  const paramsDict = params
  const filterUrl = Object.keys(paramsDict)
    .filter(key => paramsDict[key] !== null && paramsDict[key] !== '' && paramsDict[key] !== 'null')
    .sort()
    .map(key => `${key}=${paramsDict[key]}`)
    .join(':')
  if (rootUrl.endsWith('/')) {
    return `${rootUrl}${filterUrl}`
  }
  return `${rootUrl}/${filterUrl}`
}